var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DSticker6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 368,
    viewBox: "0 0 280 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2121_3277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.234 207.126C341.124 189.615 318.732 183.615 301.221 193.725C283.709 203.835 277.71 226.227 287.82 243.738C297.93 261.25 320.322 267.249 337.833 257.139C355.345 247.029 361.344 224.637 351.234 207.126Z",
    fill: "url(#paint0_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.542 209.419C324.415 191.878 301.987 185.869 284.446 195.996C266.906 206.123 260.896 228.551 271.023 246.092C281.15 263.632 303.579 269.642 321.119 259.515C338.66 249.388 344.669 226.959 334.542 209.419Z",
    fill: "url(#paint1_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.525 209.954C307.382 192.384 284.916 186.365 267.346 196.508C249.777 206.652 243.757 229.118 253.901 246.688C264.044 264.257 286.51 270.277 304.08 260.133C321.649 249.989 327.669 227.523 317.525 209.954Z",
    fill: "url(#paint2_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.326 208.667C290.164 191.066 267.658 185.035 250.057 195.197C232.456 205.359 226.426 227.866 236.588 245.467C246.749 263.068 269.256 269.098 286.857 258.936C304.458 248.774 310.488 226.268 300.326 208.667Z",
    fill: "url(#paint3_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.953 205.468C272.774 187.838 250.231 181.797 232.601 191.976C214.971 202.155 208.93 224.698 219.109 242.328C229.288 259.958 251.831 265.999 269.461 255.82C287.091 245.641 293.132 223.098 282.953 205.468Z",
    fill: "url(#paint4_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.904 200.288C255.708 182.629 233.128 176.578 215.469 186.774C197.809 196.969 191.759 219.55 201.955 237.209C212.15 254.868 234.731 260.919 252.39 250.723C270.049 240.528 276.099 217.947 265.904 200.288Z",
    fill: "url(#paint5_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.197 193.251C239.983 175.561 217.362 169.499 199.672 179.713C181.981 189.927 175.92 212.547 186.134 230.238C196.347 247.929 218.968 253.99 236.659 243.776C254.349 233.562 260.41 210.942 250.197 193.251Z",
    fill: "url(#paint6_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.017 184.376C225.786 166.656 203.128 160.585 185.409 170.816C167.689 181.046 161.618 203.704 171.848 221.424C182.079 239.143 204.737 245.214 222.456 234.984C240.176 224.754 246.247 202.096 236.017 184.376Z",
    fill: "url(#paint7_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.577 173.665C213.33 155.916 190.635 149.835 172.886 160.082C155.137 170.33 149.056 193.025 159.303 210.773C169.55 228.522 192.246 234.603 209.994 224.356C227.743 214.109 233.824 191.414 223.577 173.665Z",
    fill: "url(#paint8_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.077 161.118C202.814 143.34 180.081 137.249 162.303 147.513C144.526 157.777 138.435 180.509 148.699 198.287C158.963 216.065 181.695 222.156 199.473 211.892C217.25 201.628 223.341 178.896 213.077 161.118Z",
    fill: "url(#paint9_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.765 146.831C194.483 129.022 171.71 122.92 153.901 133.202C136.092 143.484 129.99 166.257 140.272 184.066C150.554 201.875 173.327 207.977 191.136 197.695C208.945 187.413 215.047 164.64 204.765 146.831Z",
    fill: "url(#paint10_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.028 131.48C188.729 113.641 165.92 107.529 148.081 117.828C130.243 128.127 124.131 150.937 134.43 168.775C144.729 186.613 167.539 192.725 185.377 182.426C203.215 172.127 209.327 149.318 199.028 131.48Z",
    fill: "url(#paint11_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.856 115.35C185.54 97.4832 162.694 91.3614 144.826 101.677C126.959 111.993 120.837 134.84 131.153 152.707C141.469 170.574 164.315 176.696 182.183 166.38C200.05 156.065 206.172 133.218 195.856 115.35Z",
    fill: "url(#paint12_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.155 98.6183C184.821 80.7195 161.934 74.5869 144.035 84.9208C126.136 95.2547 120.004 118.142 130.338 136.041C140.672 153.939 163.559 160.072 181.457 149.738C199.356 139.404 205.489 116.517 195.155 98.6183Z",
    fill: "url(#paint13_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.825 81.462C186.474 63.5342 163.55 57.3916 145.622 67.7422C127.694 78.0929 121.551 101.017 131.902 118.945C142.253 136.873 165.177 143.015 183.105 132.665C201.033 122.314 207.175 99.3899 196.825 81.462Z",
    fill: "url(#paint14_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.776 64.0557C190.409 46.0988 167.448 39.9463 149.491 50.3137C131.534 60.6811 125.381 83.6425 135.749 101.599C146.116 119.556 169.077 125.709 187.034 115.341C204.991 104.974 211.144 82.0126 200.776 64.0557Z",
    fill: "url(#paint15_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.662 47.2376C196.277 29.2492 173.275 23.0859 155.286 33.4715C137.298 43.8571 131.135 66.8587 141.52 84.8471C151.906 102.836 174.908 108.999 192.896 98.6132C210.884 88.2276 217.048 65.2259 206.662 47.2376Z",
    fill: "url(#paint16_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.121 31.5422C203.718 13.5247 180.68 7.35147 162.662 17.7538C144.645 28.1562 138.471 51.195 148.874 69.2125C159.276 87.2299 182.315 93.4032 200.332 83.0008C218.35 72.5984 224.523 49.5596 214.121 31.5422Z",
    fill: "url(#paint17_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.074 16.9171C212.654 -1.12942 189.578 -7.31262 171.532 3.10652C153.485 13.5257 147.302 36.6017 157.721 54.6482C168.141 72.6947 191.216 78.8778 209.263 68.4587C227.309 58.0395 233.493 34.9636 223.074 16.9171Z",
    fill: "url(#paint18_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.401 3.43486C222.963 -14.6431 199.847 -20.8371 181.769 -10.3998C163.691 0.0375624 157.497 23.1538 167.935 41.2318C178.372 59.3097 201.488 65.5037 219.566 55.0664C237.644 44.6291 243.838 21.5128 233.401 3.43486Z",
    fill: "url(#paint19_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.977 -8.81127C234.522 -26.9183 211.369 -33.1222 193.262 -22.6682C175.155 -12.2141 168.951 10.9393 179.405 29.0464C189.859 47.1534 213.013 53.3573 231.12 42.9032C249.227 32.4491 255.431 9.29576 244.977 -8.81127Z",
    fill: "url(#paint20_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.678 -19.7606C247.207 -37.8967 224.017 -44.1106 205.881 -33.6397C187.745 -23.1688 181.531 0.0217263 192.002 18.1578C202.473 36.2939 225.663 42.5078 243.799 32.0369C261.935 21.566 268.149 -1.62449 257.678 -19.7606Z",
    fill: "url(#paint21_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.391 -29.3287C260.902 -47.4963 237.671 -53.7209 219.504 -43.2319C201.336 -32.7429 195.112 -9.51206 205.601 8.6555C216.09 26.8231 239.32 33.0477 257.488 22.5587C275.656 12.0696 281.88 -11.1611 271.391 -29.3287Z",
    fill: "url(#paint22_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.986 -37.4343C275.48 -55.6309 252.212 -61.8655 234.015 -51.3597C215.819 -40.8539 209.584 -17.5859 220.09 0.61068C230.596 18.8073 253.864 25.0419 272.06 14.5361C290.257 4.0303 296.491 -19.2377 285.986 -37.4343Z",
    fill: "url(#paint23_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.336 -44.0047C290.813 -62.2304 267.508 -68.4749 249.283 -57.9523C231.057 -47.4297 224.812 -24.1246 235.335 -5.89896C245.857 12.3267 269.163 18.5713 287.388 8.04871C305.614 -2.47389 311.858 -25.779 301.336 -44.0047Z",
    fill: "url(#paint24_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.337 -48.9634C306.796 -67.2206 283.451 -73.4759 265.194 -62.9351C246.936 -52.3944 240.681 -29.0491 251.222 -10.7919C261.763 7.46526 285.108 13.7206 303.365 3.17987C321.622 -7.3609 327.878 -30.7062 317.337 -48.9634Z",
    fill: "url(#paint25_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.85 -52.2252C323.293 -70.5114 299.91 -76.7767 281.624 -66.2192C263.338 -55.6616 257.072 -32.2791 267.63 -13.9929C278.188 4.2933 301.57 10.5586 319.856 0.00104865C338.142 -10.5565 344.408 -33.939 333.85 -52.2252Z",
    fill: "url(#paint26_linear_2121_3277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.765 -53.7214C340.191 -72.0366 316.771 -78.3119 298.456 -67.7376C280.14 -57.1633 273.865 -33.7436 284.439 -15.4284C295.014 2.88691 318.433 9.16219 336.749 -1.41214C355.064 -11.9865 361.339 -35.4061 350.765 -53.7214Z",
    fill: "url(#paint27_linear_2121_3277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2121_3277",
    x1: 283.499,
    y1: 232.408,
    x2: 355.403,
    y2: 218.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2121_3277",
    x1: 266.166,
    y1: 230.948,
    x2: 339.242,
    y2: 224.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2121_3277",
    x1: 249.018,
    y1: 227.592,
    x2: 322.477,
    y2: 229.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2121_3277",
    x1: 232.142,
    y1: 222.383,
    x2: 305.154,
    y2: 231.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2121_3277",
    x1: 215.36,
    y1: 215.305,
    x2: 287.068,
    y2: 232.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2121_3277",
    x1: 199.102,
    y1: 205.974,
    x2: 268.385,
    y2: 231.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2121_3277",
    x1: 185.593,
    y1: 194.509,
    x2: 251.024,
    y2: 229.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2121_3277",
    x1: 173.837,
    y1: 181.034,
    x2: 233.713,
    y2: 224.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2121_3277",
    x1: 165.384,
    y1: 165.991,
    x2: 217.766,
    y2: 218.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2121_3277",
    x1: 159.353,
    y1: 149.351,
    x2: 202.345,
    y2: 210.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2121_3277",
    x1: 156.592,
    y1: 131.968,
    x2: 188.675,
    y2: 199.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2121_3277",
    x1: 156.598,
    y1: 114.415,
    x2: 177.059,
    y2: 186.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2121_3277",
    x1: 159.124,
    y1: 97.1105,
    x2: 168.035,
    y2: 171.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2121_3277",
    x1: 163.744,
    y1: 79.9829,
    x2: 161.772,
    y2: 154.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2121_3277",
    x1: 170.322,
    y1: 63.3904,
    x2: 158.44,
    y2: 137.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2121_3277",
    x1: 178.62,
    y1: 46.6058,
    x2: 157.91,
    y2: 118.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2121_3277",
    x1: 188.329,
    y1: 31.2785,
    x2: 159.837,
    y2: 100.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2121_3277",
    x1: 199.404,
    y1: 17.1767,
    x2: 163.617,
    y2: 83.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2121_3277",
    x1: 211.796,
    y1: 4.44504,
    x2: 169.173,
    y2: 66.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2121_3277",
    x1: 225.129,
    y1: -6.43591,
    x2: 176.179,
    y2: 51.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2121_3277",
    x1: 239.513,
    y1: -15.9988,
    x2: 184.801,
    y2: 36.3402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2121_3277",
    x1: 254.905,
    y1: -24.2187,
    x2: 195.031,
    y2: 22.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2121_3277",
    x1: 270.688,
    y1: -30.4374,
    x2: 206.261,
    y2: 9.80584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2121_3277",
    x1: 287.022,
    y1: -35.0246,
    x2: 218.691,
    y2: -1.54963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2121_3277",
    x1: 304.213,
    y1: -38.1487,
    x2: 232.676,
    y2: -11.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2121_3277",
    x1: 321.36,
    y1: -39.2401,
    x2: 247.341,
    y2: -20.5655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2121_3277",
    x1: 338.632,
    y1: -38.4795,
    x2: 262.923,
    y2: -27.7584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2121_3277",
    x1: 355.643,
    y1: -35.7863,
    x2: 279.097,
    y2: -33.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_3277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 546.754,
    height: 546.754,
    fill: "white",
    transform: "translate(273.723 432.848) rotate(-120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DSticker6);
export default __webpack_public_path__ + "static/media/3d-sticker6.05d62f01a38904daff665be6cd3501ff.svg";
export { ForwardRef as ReactComponent };